/**
 * The custom hook for automatically clearing a message after a given duration
 *
 * Copyright (c) 2022 Propellant Software Corp
 * Author: Yucho Ho
 */
import { useState, useEffect } from 'react'

const useAutoClearMessage = (errMsg, setErrMsg, duration = 3000) => {
  const [prevErrMsg, setPrevErrMsg] = useState(errMsg)
  const [timeoutID, setTimeoutID] = useState(null)

  useEffect(() => {
    if (errMsg !== prevErrMsg) {
      setPrevErrMsg(errMsg)
      clearTimeout(timeoutID)
      setTimeoutID(setTimeout(() => setErrMsg(''), duration))
    }

    return () => clearTimeout(timeoutID)
  }, [errMsg, setErrMsg, prevErrMsg, timeoutID, duration])
}

export default useAutoClearMessage
